<form [formGroup]="_form"  class="products-padding">
	<fieldset>
		<legend>{{formLabel}}</legend>
		<div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column"
            fxLayoutGap="10px">

           
<mat-form-field fxFlex=30>
    <mat-label>condition </mat-label>
    <mat-select formControlName="conjunctor"  company  name="item">
        <mat-option *ngFor="let item of condition" [value]="item">
            {{item}}
        </mat-option>
    </mat-select>
    </mat-form-field>

      <calsoft-database-rule-action-component-advanced (remove)="remove.emit()"
      [mainForm]="mainForm"
                              (addGroup)="_addGroup()"
                              [index]="formLabel"
                              (addCondition)="_addCondition()">
      </calsoft-database-rule-action-component-advanced>

      </div>
      

			<ng-container formArrayName="conditions">
        <calsoft-database-rule-condition-advanced  [mainForm]="mainForm" [types]="type" [ruleId]="ruleId" 
        
        *ngFor="let c of _conditionsFormArray?.controls; index as j" 
                            (remove)="_deleteCondition(j)"
                            [formGroup]="c"
                            [formControlName]="j" 
                            [formLabel]="'Condition ' + (j+1)">
        </calsoft-database-rule-condition-advanced>
			</ng-container>

			<ng-container formArrayName="groups">
        <!-- <calsoft-database-rule-component-advanced  *ngFor="let s of _groupsFormArray?.controls; index as i"
                            (remove)="_deleteGroupFromArray(i)" 
                            [formControlName]="i"
                            [formGroup]="s"
                            [formLabel]="'Nested Group '+ (i + 1) + ':'">
        </calsoft-database-rule-component-advanced> -->

        <ng-container *ngFor="let group of _groupsFormArray?.controls; index as i"
        [formGroupName]="i">
        <calsoft-database-rule-component-advanced 
        [mainForm]="mainForm"
          [formGroup]="group"  (remove)="_deleteGroupFromArray(i)" 
          [formControlName]="i"
          [type]="type"
          [formLabel]="'Nested Group '+ (i + 1) + ':'">
        </calsoft-database-rule-component-advanced>
      </ng-container>

       
			</ng-container>

		</div>
	</fieldset>
</form>